module.exports = __webpack_public_path__ + "img/instagram-color-icon.70b21c68.svg";